import React from 'react';
import { BrowserRouter, Redirect, Switch, Route } from 'react-router-dom';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Real from './pages/Real';
import Normalize from 'react-normalize';
import ScrollToTop from "react-scroll-to-top";
import ScrollToTop2 from "./components/ScrollToTop";

const App = () => {
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  }
  return (
    <BrowserRouter>
      <Normalize />
      <ScrollToTop smooth /> 
      <ScrollToTop2 />
      <Switch>
        <Route exact path="/accueil" component={Home} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/realisations" component={Real} />
        <Redirect to="/accueil" />
      </Switch>
   </BrowserRouter>
  );
};

export default App;